import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initCollectionSearchFilters from '../sections/collection/initCollectionSearchFilters';
import initCustomSortBy from '../sections/collection/initCustomSortBy';
import initLoadMore from '../components/load-more';
import initCollectionDescription from '../components/collection-description';

ready(() => {
  initCollectionSearchFilters();
  initCustomSortBy();
  initLoadMore();
  initCollectionDescription();
});

onShopifySectionLoad(() => {
  initCollectionSearchFilters();
  initCustomSortBy();
  initLoadMore();
  initCollectionDescription();
});
